import { Project } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllProjects from "@/v2/api/project/FindAll";

export function ProjectComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelected,
    defaultValueId,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelected?: (value: Project | null) => void;
    defaultValueId?: string;
    defaultValue: Project | null;
}) {
    return (
        <ArFormCombobox<T, Project>
            defaultValueId={defaultValueId}
            defaultValue={defaultValue}
            name={name}
            label="Select Project"
            queryKey="projects"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllProjects({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(project) => project?.name}
            renderItem={(project) => (
                <div className="flex flex-col">
                    <span>{project?.name}</span>
                    {project?.location && (
                        <span className="text-xs text-muted-foreground">
                            {project?.location}
                        </span>
                    )}
                    {project?.client?.full_name && (
                        <span className="text-xs text-muted-foreground">
                            {project?.client.full_name}
                        </span>
                    )}
                </div>
            )}
            placeholder="Select project..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(project: Project | null) => {
                setSelected && setSelected(project);
            }}
        />
    );
}
